// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"0715edef","289":"8fa0bd1e"}[chunkId] + ".chunk.js";
};